import { render, staticRenderFns } from "./PanelMerccbond.vue?vue&type=template&id=2a8234dd&scoped=true&lang=pug"
import script from "./PanelMerccbond.vue?vue&type=script&lang=js"
export * from "./PanelMerccbond.vue?vue&type=script&lang=js"
import style0 from "./PanelMerccbond.vue?vue&type=style&index=0&id=2a8234dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8234dd",
  null
  
)

export default component.exports